import { useQuery } from '@tanstack/react-query';

import { getJobsFilteredIds, GetJobsFilteredIdsParams } from 'api/jobs';

export const jobsFilteredIdsQueryKey = 'jobsFilteredIds';

export const getJobsFilteredIdsQueryKey = (params: GetJobsFilteredIdsParams) =>
  [jobsFilteredIdsQueryKey, params] as const;

export const useJobsFilteredIds = ({
  params,
  enabled = true,
}: {
  params: GetJobsFilteredIdsParams;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: getJobsFilteredIdsQueryKey(params),
    queryFn: ({ signal }) => getJobsFilteredIds(params, signal),
    enabled,
    staleTime: 60000,
  });
};

export default useJobsFilteredIds;
